import React, { useContext } from "react";
import { useFormContext } from "react-hook-form";
import { formatCollection } from "common/utils/strings";
import { Tag } from "../../../../Common/Tag";
import { viewerTypeLabel } from "./constants";
import { SubmissionsBuilderContextInstance } from "./context";
import { generateLabelsForRoles } from "./RoleAndGroupSelector";
import { FlexRowStyled } from "./SidebarColumn/__styles__/HeaderMiddleContainer";
import { SubmissionsBuilderFormDataStructure } from "./types";
import { submissionHiddenFromPublicByDefaultToViewerType } from "./utils";

export const HeaderMiddleContainer = () => {
  const { watch } = useFormContext<SubmissionsBuilderFormDataStructure>();
  const { canCreateRoles, canCreateGroups } = useContext(
    SubmissionsBuilderContextInstance,
  );

  const hiddenFromPublicByDefault = watch("hiddenFromPublicByDefault");

  const viewerType = submissionHiddenFromPublicByDefaultToViewerType(
    hiddenFromPublicByDefault,
  );

  const creatorLabels = generateLabelsForRoles(canCreateRoles);
  const groupLabels = canCreateGroups.map(userGroup => userGroup.name);

  const label = formatCollection([...creatorLabels, ...groupLabels]) ?? null;

  return (
    <FlexRowStyled>
      {label && (
        <Tag
          styleVariant="neutral"
          leftIconName="clipboard-pen"
          data-testid="creator-type-tag"
        >
          {label}
        </Tag>
      )}
      {viewerType && (
        <Tag
          styleVariant="neutral"
          leftIconName="eye"
          data-testid="viewer-type-tag"
        >
          {viewerTypeLabel[viewerType]}
        </Tag>
      )}
    </FlexRowStyled>
  );
};
